export default __webpack_public_path__ + "static/Plain-Light-e68d96b5f0cad172b23f2bb95f09d2cc.woff2";